import { redirectToLoginPage } from '../../../actions/login';
import { trackSignUp } from '../segmentAnalytics';

const handleLogin = (dispatch) => {
  trackSignUp('Sign-in');
  return dispatch(redirectToLoginPage());
};

export { handleLogin };
